const SUSPENSE_TIMEOUT = 1000 * 60 * 60 * 8 // 8 horas;
const LAST_ACTIVITY_KEY = '@conducco:lastActivity'
const USER_KEY = '@conducco:user'
const TOKEN_KEY = '@conducco:token'

export { LAST_ACTIVITY_KEY, SUSPENSE_TIMEOUT, TOKEN_KEY, USER_KEY }
